module.exports = __webpack_public_path__ + "img/Blog5.2.c3b1865b.png";